import React from 'react'
import { Link, useLocation, useMatch } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import HamburgerMenu from '../components/HamburgerMenu'

const STATIC_TITLES = {
    '/login':         'Sign In',
    '/register':      'Create Account',
    '/lobby':         'Lobby',
    '/global-lookup': 'User Lookup',
    '/top-ten':       'Top Ten Games',
    '/profile':       'My Profile',
    '/agreements/create': 'Agreements',
    '/rules':         'Rules',
    '/play':          'How To Play',
}

export default function Navbar() {
    const { isAuthenticated } = useAuth()
    const { pathname } = useLocation()
    const gameSetupMatch = useMatch('/game/:gameId/setup')
    const gamePlayMatch  = useMatch('/game/:gameId')

    let pageTitle = STATIC_TITLES[pathname] ?? null
    if (gameSetupMatch) pageTitle = 'Game Setup'
    else if (gamePlayMatch) pageTitle = 'Game Board'

    return (
        <header className="sticky top-0 z-[300] bg-bankroll-nav w-full h-[60px] flex items-center px-3 sm:h-20 relative">
            <Link className="flex items-center gap-2 text-black uppercase font-black text-2xl no-underline" to="/">
                <img src="/images/BankRollSmall.png" alt="BankRoll" className="hidden sm:block h-14 w-auto rounded-lg" />
                <span className="hidden sm:inline">BankRoll</span>
            </Link>
            {pageTitle && (
                <span className="ml-3 sm:absolute sm:left-1/2 sm:-translate-x-1/2 font-bold text-[#4D4D4D] text-lg sm:text-xl whitespace-nowrap pointer-events-none">
                    {pageTitle}
                </span>
            )}
            <nav className="ml-auto flex items-center">
                <Link className="text-[#4D4D4D] font-semibold px-5 py-1 no-underline hover:text-[#161616] hover:underline" to="/rules">Rules</Link>
                <Link className="text-[#4D4D4D] font-semibold px-5 py-1 no-underline hover:text-[#161616] hover:underline" to="/play">How To Play</Link>
            </nav>
            {isAuthenticated
                ? <HamburgerMenu />
                : <Link className="ml-2 bg-bankroll-primary text-white rounded-md px-4 py-1.5 font-semibold no-underline hover:bg-bankroll-primary-hov" to="/login">Login</Link>
            }
        </header>
    )
}
